import React from 'react';
import NotificationCard from '../../ibok-core/module/NotificationCard';
import './ServiceUnavailableMessage.less';
/**
 * Message to present to the user if we discover that the conversation
 * service is down.
 * */
var ServiceUnavailableMessage = function () { return React.createElement("div", { className: "serviceunavailablemessage" },
    React.createElement(NotificationCard, { title: "Tjenesten er utilgjengelig", type: "error" },
        React.createElement("p", null, "Vi klarer ikke \u00E5 f\u00E5 kontakt med tjenesten. Ingen meldinger vil bli levert i denne perioden."),
        React.createElement("p", null, "Problemet l\u00F8ses gjerne innen en kort periode, men si gjerne i fra til oss p\u00E5 brukerst\u00F8tte om problemet vedvarer."))); };
export default ServiceUnavailableMessage;
